<template>
<div>
  <el-form style="margin-right: 30px" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="100px" class="demo-ruleForm">
    <el-form-item label="设备编号" prop="deviceid">
      <el-input v-if="padRow.isAdd === 1" placeholder="请输入设备编号" style="width: 100%" v-model="addEditForm.deviceid"></el-input>
      <span v-else>{{addEditForm.deviceid}}</span>
    </el-form-item>
    <el-form-item label="设备类型" prop="devicetype">
      <el-select v-fixZoom :disabled="padRow.isAdd !== 1" style="width: 100%" v-model="addEditForm.devicetype" placeholder="请选择">
        <el-option v-for="item in devicetypes" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item v-if="padRow.isAdd === 3" label="所属组织" prop="orgid">
      <el-cascader v-fixZoom style="width: 100%" :options="treeData"
                   v-model="addEditForm.orgid" :filterable="true" placeholder="请选择组织"
                   :props="{ checkStrictly: true, value: 'id', label: 'name', children: 'child', emitPath: false}"
                   ref="orgOptions" @change="getAccountData">
      </el-cascader>
    </el-form-item>
    <el-form-item v-if="padRow.isAdd === 3" label="绑定账号" prop="sys_user_id">
      <el-select v-fixZoom v-model="addEditForm.sys_user_id" placeholder="请选择账号" style="width: 100%">
        <el-option v-for="item in showAcc" :key="item.value" :label="item.username" :value="item.id">
        </el-option>
      </el-select>
    </el-form-item>
  </el-form>
  <div style="margin-top: 50px">
    <el-row style="margin: 0 20px">
      <el-col :span="12">
        <div class="cancel-btn" @click="closeAdd()">
          <span>取消</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="send-btn" @click="submitAddEdit('addEditForm')">
          <span>确定</span>
        </div>
      </el-col>
    </el-row>
  </div>
</div>
</template>

<script>
import {addpad, binddevicetosysuser, editpad} from '../../../api/yanglaoyuan'
import {queryuserbyorgid} from '../../../api/account'
export default {
  name: 'padAddDevice',
  model: {
    prop: 'addShow',
    event: 'change'
  },
  props: {
    padRow: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      devicetypes: [
        {id: 850, name: '壁挂信息屏'},
        {id: 851, name: '床头探视终端'},
        {id: 852, name: '移动护理终端'}
      ],
      addEditForm: {
        id: 0,
        deviceid: '',
        devicetype: '',
        orgid: '',
        sys_user_id: '',
        operate_model: '1' // 操作模式护工平板传 1
      },
      addEditRules: {
        deviceid: [
          { required: true, message: '请输入设备编号', trigger: 'change' }
        ],
        devicetype: [
          { required: true, message: '请选择设备类型', trigger: 'change' }
        ],
        orgid: [
          { required: true, message: '请选择组织', trigger: 'change' }
        ],
        sys_user_id: [
          { required: true, message: '请选择绑定账号', trigger: 'change' }
        ]
      },
      treeData: [],
      showAcc: []
    }
  },
  created () {
    this.treeData = this.padRow.treeData
    if (this.padRow.isAdd !== 1) {
      this.addEditForm.id = this.padRow.row.id
      this.addEditForm.deviceid = this.padRow.row.deviceid
      this.addEditForm.devicetype = this.padRow.row.devicetype
      this.addEditForm.orgid = this.padRow.row.orgid
    }
  },
  methods: {
    getAccountData (id) {
      let data = {orgid: id}
      queryuserbyorgid(data).then(res => {
        this.showAcc = res.data.users
      }).catch(() => {
      })
    },
    closeAdd () {
      this.$emit('change', false)
    },
    submitAddEdit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.padRow.isAdd === 1) {
            let data = {
              id: 0,
              deviceid: this.addEditForm.deviceid,
              devicetype: this.addEditForm.devicetype
            }
            addpad(data).then(res => {
              this.$notify({title: '成功', message: '成功录入设备', type: 'success'})
              this.$emit('getFatherChange')
              this.$emit('change', false)
            }).catch(() => {})
          } else if (this.padRow.isAdd === 2) {
            let data = {
              // id: this.addEditForm.id,
              device_id: this.addEditForm.deviceid,
              device_type: this.addEditForm.devicetype
            }
            editpad(data).then(res => {
              this.$notify({title: '成功', message: '成功编辑设备', type: 'success'})
              this.$emit('getFatherChange')
              this.$emit('change', false)
            }).catch(() => {})
          } else if (this.padRow.isAdd === 3) {
            let send = {
              'imei': this.addEditForm.deviceid,
              'did': this.addEditForm.id,
              'dtype': this.addEditForm.devicetype,
              'orgid': this.addEditForm.orgid,
              'sys_user_id': this.addEditForm.sys_user_id,
              'operate_model': '1' // 操作模式护工平板传 1
            }
            binddevicetosysuser(send).then(res => {
              this.$notify({title: '成功', message: '成功绑定账号', type: 'success'})
              this.$emit('getFatherChange')
              this.$emit('change', false)
            }).catch(() => {
              this.$notify.error({ title: '失败', message: '绑定失败' })
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/padAddDevice.vue